module.exports = __webpack_public_path__ + "assets/img/hanhuadanbao.ab0aace0.png";